module.exports = __webpack_public_path__ + "static/course-image-00305c5017aa10cf1aaa583b5f52190f.png";